import _merge from 'lodash-es/merge';
import { SmallScreenTabs } from './SmallScreenTabs';
import { LargeScreenTabs } from './LargeScreenTabs';

const DEFAULT_OPTIONS = {
    selector: '.ghwp-tabs',
    tabBreakpoint: '767px',
};
/**
 * Responsive tabs (accordion on small screens)
 *
 * @param {object}      options
 * @param {null|string} options.selector - selector for tab wrapper
 * @param {null|string} options.selectorTabList - selector for tab list
 * @param {null|string} options.selectorPanel - selector for tab panels
 * @param {null|string} options.selectorTitle - selector for tab title
 * @param {null|string} options.selectorContent - selector for tab content
 * @param {null|string|boolean} options.tabBreakpoint - max-width up until which this is an accordion
 * @param {ResizeListener|null} resizeListener
 */
export const tabsFactory = (options = {}, resizeListener) => {
    const parsedOptions = _merge(DEFAULT_OPTIONS, options);
    const { selector, tabBreakpoint } = parsedOptions;
    let lastScreenSizeWasSmall = false;

    const tabGroups = document.querySelectorAll(selector);
    if (tabGroups.length === 0) {
        // No tabs on page, short circuit
        return null;
    }

    let isSmallScreen = () =>
        window.matchMedia(`(max-width: ${tabBreakpoint})`).matches;

    if (tabBreakpoint !== false) {
        lastScreenSizeWasSmall = isSmallScreen();
    }

    const init = () => {
        tabGroups.forEach((tabContainer) => {
            if (tabBreakpoint !== false && isSmallScreen()) {
                return new SmallScreenTabs(
                    tabContainer,
                    options,
                    resizeListener
                );
            } else {
                return new LargeScreenTabs(
                    tabContainer,
                    options,
                    resizeListener
                );
            }
        });
    };

    init();
    if (tabBreakpoint !== false && resizeListener) {
        resizeListener.subscribe('resize', () => {
            if (isSmallScreen() !== lastScreenSizeWasSmall) {
                init();
                lastScreenSizeWasSmall = isSmallScreen();
            }
        });
    }
};
